import { Link, type LinkProps } from 'react-router';
import { resolveHref } from '@/lib/site-config';

/**
 * Link wrapper that rewrites internal docs/blog paths to logpulse.io when
 * the current build is a non-EN ccTLD. Marketing paths stay relative (each
 * domain serves its own marketing content at root paths).
 */
export function LocalizedLink({ to, ...rest }: LinkProps) {
  if (typeof to === 'string') {
    const target = resolveHref(to);
    if (target.startsWith('http')) {
      return <a href={target} {...rest} />;
    }
    return <Link to={target} {...rest} />;
  }
  return <Link to={to} {...rest} />;
}

/** Same as LocalizedLink but for plain anchor tags (hash links, etc.). */
export function LocalizedAnchor({ href, ...rest }: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  const target = href ? resolveHref(href) : href;
  return <a href={target} {...rest} />;
}
